@include sustainability-theme;

:host {
    display: block;
    position: relative;
    aspect-ratio: 16 / 9;
}
